import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import classNames from "classnames";
import React from "react";
import * as s from "./DatepickerInput.sss";
export const DatepickerInput = ({ onChange, maxDate, minDate, placeholder, className, value, }) => {
    return (React.createElement("div", { className: s.root },
        React.createElement("label", { htmlFor: "datepicker", className: s.datepickerLabel },
            React.createElement(DatePicker, { className: classNames(s.input, s.datePicker, className), name: "date", onChange: (date) => {
                    onChange(date.toDate());
                }, value: value, label: placeholder, format: "DD.MM.YYYY", maxDate: maxDate, minDate: minDate, closeOnSelect: true }))));
};
export default DatepickerInput;
